/** Name to display for team */
export const TEAM_DISPLAY_NAME = "team";

/** Name to display for teams */
export const TEAMS_DISPLAY_NAME = "teams";
